// const group = {
//   FACHHANDEL: 1,
//   WERBE: 2,
//   PRESSE: 3
// }

import { action, observable } from "mobx"
import customerStore from "stores/customerStore";

export default class SessionModelBase {

  @observable customer = false
  @observable costCentres = []
  @observable activeCostCentreId = false

  constructor( data, shop ) {
    this.shop = shop
    Object.assign( this, data )
    console.log( "CC NEW", data )
    const { restoreId } = customerStore
    if ( restoreId ) {
      console.log( "Set CUSTOMER FROM RESTORE TOKEN" )
      customerStore.setCustomer( restoreId )
    }

    // kostenstellen des kunden laden
    this.prepare();

    this.canUseCartApi = typeof this.value === "object"
  }


  async prepare() {
    if (this.shopuser && this.shopuser.customer)
      this.costCentres = await this.shop.fetch( `/shop/rest/costcentre/data?start=0&count=120&customer=${this.shopuser.customer}` )
    console.log( "CC", this.costCentres )
  }

  @action
  setCostCentre( costCentreId ) {
    this.activeCostCentreId = costCentreId
    this.shop.cart.data.costcentre = costCentreId
    this.shop.cart.saveImmediate()
  }

  @action
  setCustomer( customer ) {
    console.log('SET CUSTOMER');
    this.customer = customer
    this.prepare()
  }

  hasGroup( groupName ) {
    return this.group === groupName
  }

  hasRole( roleName ) {
    return this.shopuser && this.shopuser.roles && this.shopuser.roles.some( role => `${role}`.toUpperCase() === `${roleName}`.toUpperCase() )
  }

  destroy() {
    sessionStorage.clear()
  }
}



// WEBPACK FOOTER //
// ./src/theme/oehme/shop/SessionModel.js